import Vue from "vue";
import VueExcelEditor from "vue-excel-editor";
import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from "../../../mixin/mixin.js";
Vue.use(VueExcelEditor);

export default {
  mixins: [mixx],
  name: 'cuponesLiquidados',
  data() {
    return {
      msg: '-',
      data: [],
      loading: false,
      loading_f: false,
      ventas: [],
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      }
    }
  },
  unmounted() {
    this.tbv.destroy();
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $(".box").boxWidget();
    
    this.tbv = $("#ventas").DataTable({
      paging: true,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      order: [],
      autoWidth: true,
      orderCellsTop: true,
      fixedHeader: true,
      rowCallback: function (row, data, index) { }
    });
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function () {
      return (
        "/reportes/cupones/liquidados?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&estado=" +
        this.f_c.estado
      );
    }
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post(
          "/reportes/cupones/liquidados", this.f_c
        )
        .then(response => {
          
            response.data.data.forEach(element => {
              element[12] = this.num_to_many(element[12]);
              element[13] = this.num_to_many(element[13]);

              element[18] = this.num_to_many(element[18]);
              element[19] = this.num_to_many(element[19]);
              element[20] = this.num_to_many(element[20]);
              element[21] = this.num_to_many(element[21]);
              element[22] = this.num_to_many(element[22]);
              this.tbv.row.add(element);
            });
          
          this.tbv.draw();
          this.loading = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/cuponesLiquidados/index.js